// Mock data for Analytica landing page

export const heroData = {
  title: "Software 100% personalizado para tu negocio… en solo 60 días.",
  subtitle: "Automatiza procesos, elimina errores y escala tu operación con soluciones hechas a medida.",
  ctaPrimary: "Quiero mi sistema personalizado",
  ctaSecondary: "Agenda una llamada"
};

export const servicesData = {
  title: "Creamos software a la medida de tu negocio.",
  description: "Desarrollamos soluciones tecnológicas que se adaptan perfectamente a tus procesos, eliminando las limitaciones del software genérico y potenciando tu productividad.",
  services: [
    {
      icon: "Cog",
      title: "Automatización completa",
      description: "Elimina tareas repetitivas y reduce errores humanos con flujos de trabajo automatizados."
    },
    {
      icon: "Building2",
      title: "Sistemas empresariales",
      description: "CRM, inventarios, órdenes de compra y más. Todo integrado en una sola plataforma."
    },
    {
      icon: "Plug",
      title: "Integraciones inteligentes",
      description: "Conectamos tu sistema con APIs de terceros para un flujo de datos sin fricciones."
    },
    {
      icon: "TrendingUp",
      title: "Optimización de procesos",
      description: "Analizamos y mejoramos tus operaciones para maximizar eficiencia y resultados."
    }
  ]
};

export const processData = {
  title: "Nuestro proceso está diseñado para velocidad y precisión.",
  steps: [
    {
      day: "Semana 1-2",
      title: "Diagnóstico y planificación",
      description: "Analizamos tus necesidades y definimos el alcance del proyecto."
    },
    {
      day: "Semana 2-3",
      title: "Diseño y prototipo",
      description: "Creamos el diseño visual y la arquitectura de tu sistema."
    },
    {
      day: "Semanas 3-6",
      title: "Desarrollo",
      description: "Construimos tu sistema con tecnología de vanguardia."
    },
    {
      day: "Día 60",
      title: "Entrega + capacitación",
      description: "Te entregamos el sistema funcionando y capacitamos a tu equipo."
    }
  ]
};

export const casesData = {
  title: "Transformamos procesos manuales en sistemas automáticos.",
  cases: [
    {
      title: "Alfa-Field Connect · Field Service Telecom",
      description: "Digitalización end-to-end de operaciones de campo: agendamiento, ejecución móvil con geo-validación, inventario multi-bodega y monitoreo GPS en vivo.",
      image: "alfafield",
      badge: "2026 · Ecuador",
      year: 2026,
      country: "Ecuador",
      client: "TELEALFACOM S.A. (Alfanet)",
      metrics: [
        { label: "Nodos de reglas auditables", value: "228" },
        { label: "Tickets QA cerrados", value: "35/35" },
        { label: "Reducción tiempo cierre OT", value: "-68%" },
      ],
      problem: "El equipo operaba con Excel + WhatsApp para agendar cientos de órdenes de trabajo semanales. Sin geo-validación al cierre, sin trazabilidad de materiales y con reglas de negocio dispersas que solo el jefe de zona conocía de memoria.",
      solution: "Diseñamos un árbol jerárquico de 228 nodos con reglas en cascada (SLA, materiales, tecnología, PVP) que se propaga automáticamente. El técnico ejecuta con app móvil (Expo) con Waze integrado, fotos firmadas y geo-validación por polígono al cerrar. Supervisores monitorean flota en vivo y auditan cierres.",
      process: [
        { step: "Workshop", detail: "Mapeo del árbol de tipos de solución con los 6 supervisores regionales" },
        { step: "MVP 60 días", detail: "OTs + agendamiento + app móvil técnicos con geo-validación" },
        { step: "Sprint 2", detail: "Inventario por bodega con series + monitoreo GPS en vivo" },
        { step: "QA 3 rondas", detail: "35 tickets del cliente cerrados con evidencia fotográfica" },
        { step: "Integración Odoo", detail: "Sync OTs ↔ facturación (workshop 27 preguntas)" },
      ],
      tech: "React · Tailwind · Shadcn · Expo React Native · FastAPI · MongoDB + AWS RDS PostgreSQL · Leaflet · Mailgun · OSM · Odoo V15",
      link: "https://alfafiel.analytica-ec.com",
    },
    {
      title: "Neuromatemáticas JASQ · LMS con IA",
      description: "Plataforma multi-franquicia para enseñar matemáticas con clases en vivo, pizarra colaborativa, quizzes en tiempo real y acompañamiento integral del estudiante.",
      image: "neuromatematicas",
      badge: "2026 · México",
      year: 2026,
      country: "México",
      client: "Neuromatemáticas JASQ",
      metrics: [
        { label: "Franquicias activas", value: "12+" },
        { label: "Grabaciones optimizadas", value: "100%" },
        { label: "Compatibilidad iOS/Safari", value: "100%" },
      ],
      problem: "La institución operaba con Zoom, WhatsApp y Google Drive por separado. Los docentes no podían escribir matemáticas en vivo, los estudiantes menores de edad no tenían seguimiento cualitativo y las grabaciones no reproducían en iPhone.",
      solution: "Construimos un LMS con clases en vivo Jitsi + pizarra Excalidraw (control de escritura por docente, OCR de fotos con Gemini, resaltador y fórmulas matemáticas). Quizzes en vivo con fallback por polling. Grabaciones convertidas a MP4 ligero con ffmpeg compatible con Safari. Diagnóstico cualitativo sin notas.",
      process: [
        { step: "Diseño UX niños", detail: "Interfaz amigable con mascota guía 'Zarek' y colores estéticos Sora" },
        { step: "Motor de clases", detail: "Jitsi + Excalidraw con permisos por rol docente/alumno" },
        { step: "Notificaciones", detail: "Recordatorios 24h/2h antes de clase, zona horaria CDMX forzada" },
        { step: "Blindaje QA", detail: "Fallback por polling para quiz y pizarra si WS bloqueado" },
        { step: "Grabaciones", detail: "Backblaze B2 + ffmpeg para reproducción en iOS" },
      ],
      tech: "React + Tailwind + Shadcn · FastAPI + MongoDB · Jitsi · Excalidraw · Gemini/OpenAI · ElevenLabs · Backblaze B2 · Stripe · ffmpeg",
    },
    {
      title: "Turismo MDD · Despacho de taxis con IA",
      description: "Plataforma integral que digitaliza el despacho de una empresa de taxis con 20+ años de radio-teléfono. Bot WhatsApp con IA, apps móviles, auto-asignación real.",
      image: "turismo",
      badge: "2026 · Perú",
      year: 2026,
      country: "Perú",
      client: "Turismo Madre de Dios",
      metrics: [
        { label: "Canales unificados", value: "3" },
        { label: "Radio ≤15 km match", value: "Real" },
        { label: "Verificación PIN pasajero", value: "5 dígitos" },
      ],
      problem: "Puerto Maldonado tenía una operadora de taxis que despachaba por radio HF y llamadas. Sin trazabilidad de carreras, sin verificación de pasajero, sin auditoría — y con dispatchers saturados.",
      solution: "Panel web para dispatchers + apps móviles para conductores y pasajeros + bot WhatsApp que recibe voz/texto/GPS y crea carreras. Auto-asignación real con Haversine (conductor online + GPS ≤5 min + no ocupado). Editor de zonas tarifarias en mapa. PIN de seguridad al iniciar viaje.",
      process: [
        { step: "Diagnóstico terreno", detail: "Visita a Puerto Maldonado para mapear zonas tarifarias reales" },
        { step: "Bot WhatsApp", detail: "2chat.io + Claude Sonnet 4.6 + Whisper para transcribir voz" },
        { step: "Apps móviles", detail: "React Native con biometría, mapa en vivo, notificaciones push" },
        { step: "Editor zonas", detail: "Polígonos en mapa Leaflet con tarifas por tipo de vehículo" },
        { step: "Seguridad", detail: "PIN de verificación + botón SOS + auditoría de cambios" },
      ],
      tech: "React + Shadcn + Leaflet · FastAPI + MongoDB Atlas · Expo React Native (2 apps) · 2chat.io · Claude Sonnet 4.6 · Whisper · JWT",
      link: "https://turismo.mdd.analytica-ec.com",
    },
    {
      title: "Analytica Pro · Inteligencia de precios",
      description: "Sistema full-stack de análisis de precios y competitividad farmacéutica para el grupo DIFARE / Farmacias Cruz Azul. Dashboards tipo Power BI y simuladores.",
      image: "analytica_pro",
      badge: "2026 · Ecuador",
      year: 2026,
      country: "Ecuador",
      client: "Farmacias Cruz Azul (DIFARE)",
      metrics: [
        { label: "Colecciones Mongo", value: "10+" },
        { label: "Cache SHA256 TTL", value: "30 min" },
        { label: "Filtro anti-outliers", value: "37.72% depurado" },
      ],
      problem: "El equipo comercial de DIFARE monitoreaba precios de competencia con Excel manuales que llegaban 15 días tarde. No podían medir CPI, dsct GD, ni simular márgenes en tiempo real.",
      solution: "Investigadores suben capturas en campo → pipeline cruza con maestros DIFARE (df_maestro_negociacion, pvpx_difare) → dashboards con drill-down por Competidor/Tabla/Laboratorio + simulador de márgenes con IVA selectivo. Fórmulas 100% ponderadas.",
      process: [
        { step: "Modelo de datos", detail: "10 colecciones normalizadas con auditoría de purga" },
        { step: "Fórmulas oficiales", detail: "CPI, Dsct GD, Dsct COMPE, Precio Cons, Precio Compe todas ponderadas" },
        { step: "Dashboards", detail: "3 vistas con Modo Enfoque fullscreen y filtros globales" },
        { step: "Optimización", detail: "Denormalización + jobs async con polling + cache SHA256" },
        { step: "Simulador", detail: "Cálculo dinámico de margen con notificaciones vía Resend" },
      ],
      tech: "React + Tailwind + Recharts · FastAPI + MongoDB Atlas · asyncio.gather · JWT · Resend",
      link: "https://difare.analytica-ec.com",
    },
    {
      title: "Sistema de inventarios para retail",
      description: "Control total de stock, alertas automáticas de reposición y reportes en tiempo real.",
      image: "inventory",
      badge: "Retail",
      year: 2025,
      country: "Ecuador",
      client: "Retail Solutions S.A.",
      metrics: [
        { label: "Reducción quiebres stock", value: "-40%" },
        { label: "Horas manuales ahorradas/sem", value: "20h" },
        { label: "Trazabilidad", value: "100%" },
      ],
      problem: "La cadena manejaba stock en Excel replicado en 8 sucursales. Errores de 5-10% mensuales y quiebres constantes de productos estrella.",
      solution: "Sistema centralizado con lectura de código de barras, alertas por umbrales configurables por sucursal y bot de reposición automática.",
      process: [
        { step: "Integración POS", detail: "Sync en tiempo real con el punto de venta existente" },
        { step: "Umbrales por sucursal", detail: "Alertas configurables por SKU × ubicación" },
        { step: "Reportes ejecutivos", detail: "Dashboards diarios enviados por email" },
      ],
      tech: "React · FastAPI · MongoDB · Cloudinary · Emails automáticos",
    },
    {
      title: "CRM para servicios profesionales",
      description: "Gestión de clientes, seguimiento de ventas y automatización de comunicaciones.",
      image: "crm",
      badge: "Servicios",
      year: 2025,
      country: "Ecuador",
      client: "Servicios Integrados",
      metrics: [
        { label: "Recuperación inversión", value: "1er mes" },
        { label: "Tasa de conversión", value: "+32%" },
        { label: "Ciclo comercial", value: "-50%" },
      ],
      problem: "Los vendedores usaban WhatsApp personal y hojas de Excel. Perdían leads, no había seguimiento y no se podía medir productividad.",
      solution: "CRM con pipeline visual estilo Kanban, plantillas de email/WhatsApp, seguimiento automático de recordatorios y reportes de conversión por vendedor.",
      process: [
        { step: "Mapeo de pipeline", detail: "5 etapas con criterios de avance definidos por Gerencia Comercial" },
        { step: "Integraciones", detail: "WhatsApp Business + email transaccional + calendario" },
        { step: "Automatizaciones", detail: "Follow-up automático a 3/7/15 días sin respuesta" },
      ],
      tech: "React · FastAPI · MongoDB · WhatsApp Business API · Google Calendar",
    },
  ]
};

export const testimonialsData = {
  testimonials: [
    {
      name: "Carlos Mendoza",
      position: "Director de Operaciones",
      company: "Retail Solutions S.A.",
      text: "En solo 60 días tuvimos un sistema de inventarios que nos ha ahorrado más de 20 horas semanales en trabajo manual.",
      avatar: "CM"
    },
    {
      name: "María Fernanda López",
      position: "Gerente General",
      company: "Servicios Integrados",
      text: "El CRM que desarrollaron transformó completamente nuestra gestión de clientes. La inversión se recuperó en el primer mes.",
      avatar: "ML"
    },
    {
      name: "Roberto Sánchez",
      position: "Jefe de Compras",
      company: "Industrial Norte",
      text: "Las órdenes de compra que antes tardaban días en aprobarse, ahora se procesan en minutos. Increíble eficiencia.",
      avatar: "RS"
    }
  ]
};

export const aboutData = {
  title: "Somos Analytica: precisión, velocidad y soluciones reales.",
  description: "Con más de 5 años de experiencia en automatización y desarrollo de software personalizado, hemos ayudado a empresas de todos los tamaños a transformar sus operaciones. Nuestro enfoque combina la velocidad de entrega con la precisión técnica, garantizando soluciones que realmente funcionan."
};

export const clientsData = {
  title: "Empresas que confían en nosotros",
  clients: [
    {
      name: "Alfanet",
      country: "Ecuador",
      flag: "🇪🇨",
      logo: "https://res.cloudinary.com/dmcizw1zs/image/upload/v1784835785/clients/alfanet.png",
      tagline: "Alfa-Field Connect · Field-service para telecom",
      description: "Plataforma web + móvil de gestión de operaciones de campo para TELEALFACOM S.A. Digitaliza el ciclo completo de la Orden de Trabajo (OT): agendamiento por sucursal/zona, ejecución con app móvil (Waze, fotos, firmas, geo-validación), inventario por bodega, monitoreo GPS de técnicos e integración con Odoo V15. Producción activa en alfafiel.analytica-ec.com — v1.9.5 con 35/35 tickets QA cerrados.",
      stack: "React + FastAPI + Expo React Native · MongoDB + AWS RDS PostgreSQL · Leaflet · Odoo",
      highlight: "228 nodos de reglas en cascada auditable · geo-validación al cierre",
    },
    {
      name: "Neuromatemáticas JASQ",
      country: "México",
      flag: "🇲🇽",
      logo: "https://res.cloudinary.com/dmcizw1zs/image/upload/v1784835831/clients/neuromatematicas.png",
      tagline: "LMS multi-franquicia para enseñar matemáticas con IA",
      description: "Plataforma educativa multi-tenant en español enfocada en enseñanza de matemáticas con clases en vivo interactivas: video (Jitsi), pizarra colaborativa (Excalidraw), quizzes en tiempo real y grabaciones ligeras compatibles con iOS/Safari. Diagnóstico cualitativo del estudiante, rutas de aprendizaje con IA evolutiva y acompañamiento integral (académico + emocional).",
      stack: "React + FastAPI + MongoDB · Jitsi · Excalidraw · Gemini/OpenAI · Backblaze B2 · Stripe",
      highlight: "Acompañamiento integral · zona horaria México · certificación docente",
    },
    {
      name: "Turismo MDD",
      country: "Perú",
      flag: "🇵🇪",
      logo: "https://res.cloudinary.com/dmcizw1zs/image/upload/v1784835784/clients/turismo_mdd.jpg",
      tagline: "Despacho corporativo de taxis · Puerto Maldonado",
      description: "Plataforma integral de gestión de flota que digitaliza el despacho de una empresa de taxis con 20+ años de operación por radio/teléfono. Combina panel web administrativo, bot de WhatsApp con IA (Claude + Whisper para voz y ubicación GPS), apps móviles para conductores y pasajeros, editor de zonas tarifarias en mapa y auto-asignación real por distancia (Haversine).",
      stack: "React + FastAPI + MongoDB Atlas · Expo (2 apps) · 2chat.io · Claude Sonnet 4.6 · Whisper",
      highlight: "Matching real por GPS · PIN de seguridad · SOS · producción en turismo.mdd.analytica-ec.com",
    },
    {
      name: "Farmacias Cruz Azul",
      country: "Ecuador",
      flag: "🇪🇨",
      logo: "https://customer-assets.emergentagent.com/job_rapid-systems/artifacts/ap86mz93_Logo%20Cruz%20Azul%20sin%20fondo.png",
      tagline: "Analytica Pro · Inteligencia competitiva farmacéutica",
      description: "Sistema full-stack de inteligencia competitiva y análisis de precios para el sector farmacéutico del grupo DIFARE. Combina captura de investigación de campo, pipelines de procesamiento y dashboards tipo Power BI con Modo Enfoque fullscreen. 3 vistas interactivas (Competidor · Tabla · Laboratorio), simulador de ventas con IVA selectivo, KPI de competitividad y CPI ponderado. Producción: difare.analytica-ec.com.",
      stack: "React + FastAPI + MongoDB Atlas · Recharts · JWT · Resend · Jobs async con polling",
      highlight: "Fórmulas 100% ponderadas · cache SHA256 · filtro anti-outliers · drill-down por producto",
    },
    {
      name: "DIFARE",
      logo: "https://customer-assets.emergentagent.com/job_rapid-systems/artifacts/deebekul_Logo-DIFARE%202024.jpg"
    },
    {
      name: "G&H Auditores",
      logo: "https://customer-assets.emergentagent.com/job_3ee71ab0-856c-41a8-8e43-f382a70126f5/artifacts/yx5e5e8u_gyh%20auditores.png"
    },
    {
      name: "ITECSUR",
      logo: "https://customer-assets.emergentagent.com/job_3ee71ab0-856c-41a8-8e43-f382a70126f5/artifacts/pck4x682_Itecsur.png"
    },
    {
      name: "Distribuidora Delta",
      logo: "https://customer-assets.emergentagent.com/job_3ee71ab0-856c-41a8-8e43-f382a70126f5/artifacts/pwhlscj9_delta.png"
    },
    {
      name: "Proveedora Nova",
      logo: "https://customer-assets.emergentagent.com/job_3ee71ab0-856c-41a8-8e43-f382a70126f5/artifacts/97u10k6v_proveedora.png"
    },
    {
      name: "PharmaGroup Solutions",
      logo: "https://customer-assets.emergentagent.com/job_3ee71ab0-856c-41a8-8e43-f382a70126f5/artifacts/tdyrr9k6_pharma.png"
    },
    {
      name: "Comercial Oriente",
      logo: "https://customer-assets.emergentagent.com/job_3ee71ab0-856c-41a8-8e43-f382a70126f5/artifacts/1i4ameo2_oriente.png"
    }
  ]
};

export const ctaData = {
  title: "¿Listo para tu sistema personalizado?",
  subtitle: "Transforma tu negocio con tecnología hecha a tu medida.",
  ctaPrimary: "Solicitar cotización",
  ctaSecondary: "Hablar por WhatsApp"
};

export const contactData = {
  email: "gerencia@analytica-ec.com",
  whatsapp: "+593991466821",
  whatsappLink: "https://wa.me/593991466821",
  address: "Av Naciones Unidas y 10 de Agosto, Edificio Metropolitan",
  logo: "https://customer-assets.emergentagent.com/job_43c3bb17-ce34-4538-b42a-f72cbd23079a/artifacts/i2u4mzq9_LOGO%20ANALYTICA.png"
};
